export enum SUCCESS_CODE_ENUMERATION {
  STANDARD_SUCCESS = '0000',
  CONDITIONAL_SUCCESS = '1403',
}
